import { CardElement, CardElementChangeEvent } from "@recurly/react-recurly";
import classNames from "classnames";
import { forwardRef, useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Button, ButtonKind } from "../../../../../core/ui";
import Heading from "../../../../../core/ui/Heading.component";

interface CoastPaymentDetailsProps {
  goForward: () => void;
  onCancel: () => void;
  goBacktoStepOne: () => void;
  stepNumber: number;
  stepCount: number;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  hidden: boolean;
  country: string;
  phone: string;
  state: string;
  city: string;
  zip: string;
}

export interface PaymentFormInputs {
  paymentType: "card" | "bank-account";
  accountType: "checking" | "savings";
  confirmAccountNumber?: "string";
  routingNumber?: "string";
  accountNumber?: "string";
}

export const CoastPaymentDetails = forwardRef<HTMLFormElement, CoastPaymentDetailsProps>(
  (
    {
      goForward,
      onCancel,
      goBacktoStepOne,
      hidden,
      stepNumber,
      stepCount,
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      zip,
      country,
      phone,
    },
    forwardedRef,
  ) => {
    const { handleSubmit, errors, watch } = useFormContext<PaymentFormInputs>();
    const paymentTypeWatcher = watch("paymentType");

    const className = classNames("component-payment-details", "sign-up-step", { hidden });
    const [isCardValid, setIsCardValid] = useState(false);

    const handleCardElementEvent = useCallback(
      ({ valid }: CardElementChangeEvent) => {
        if (valid !== isCardValid) {
          setIsCardValid(valid);
        }
      },
      [isCardValid],
    );

    return (
      <section className={className}>
        <p className="step-indicator">
          Step {stepNumber} of {stepCount}
        </p>

        <Heading level={2} className="section-title">
          Enter Your Payment Details
        </Heading>

        {/* Once https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35572 is resolved, remove "!"*/}
        <form onSubmit={handleSubmit(goForward)} ref={forwardedRef!}>
          <CardElement onChange={handleCardElementEvent} />
          <input
            value={`${firstName} ${lastName}`}
            data-recurly="name_on_account"
            readOnly={true}
            hidden={true}
            type="text"
          />
          <input value={firstName || ""} data-recurly="first_name" readOnly={true} hidden={true} type="text" />
          <input value={lastName || ""} data-recurly="last_name" readOnly={true} hidden={true} type="text" />
          <input value={address1 || ""} data-recurly="address1" readOnly={true} hidden={true} type="text" />
          <input value={address2 || ""} data-recurly="address2" readOnly={true} hidden={true} type="text" />
          <input value={city || ""} data-recurly="city" readOnly={true} hidden={true} type="text" />
          <input value={state || ""} data-recurly="state" readOnly={true} hidden={true} type="text" />
          <input value={zip || ""} data-recurly="postal_code" readOnly={true} hidden={true} type="text" />
          <input value={country || ""} data-recurly="country" readOnly={true} hidden={true} type="text" />
          <input value={phone || ""} data-recurly="phone" readOnly={true} hidden={true} type="text" />

          <div className="button-prev-next">
            <Button
              disabled={!!Object.values(errors).length || (paymentTypeWatcher === "card" && !isCardValid)}
              kind={ButtonKind.CUSTOMIZED}
              className="button-continue"
              type="submit"
            >
              Continue
            </Button>
            <Button kind={ButtonKind.CUSTOMIZED} className="button-previous" click={goBacktoStepOne}>
              Previous
            </Button>
          </div>
        </form>

        <Button kind={ButtonKind.CUSTOMIZED} className="button-cancel" click={onCancel}>
          Cancel
        </Button>
      </section>
    );
  },
);
